import type { InstitutionTheme } from '../types';
import { mercedCollegeColors } from './colors';

// Merced College institutional theme (Worker B S3, 2026-09-05).
// THIS IS MERCED COLLEGE (Merced Community College District, mccd.edu) —
// NOT UC Merced (`../ucmerced`). Never merge the two entries.
//
// Brand strings from the 2026-27 Coursedog catalog (catalog.mccd.edu) and
// the S1 decisions rev 3 (brand confirmed by the owner via the driver).
// registrationPortalName VERIFIED first-party 2026-09-06 (PR #313 review):
// "MC Portal" is the global-nav link on www.mccd.edu ("Enroll | MC Portal |
// Canvas"), href https://experience.elluciancloud.com/mc789/ (Ellucian
// Experience). The fact sheet's `assumed` confidence on this leaf is
// superseded.
//
// Example course codes vetted against the S0 index (902 codes,
// probes/course_index_s0.json): CPSC-01 (Introduction to Computer Science —
// zero-padded 2-digit local number, the everyday shape), ENGL-C1000 (the
// AB 1111 Common Course Numbering shape), BIOL-04A (letter-suffixed
// sequence part). All three are hyphenated — the one shape no other live
// institution has. First entry is the primary example.
export const mercedCollegeTheme: InstitutionTheme = {
  slug: 'merced-college',
  universityName: 'Merced College',
  universityShortName: 'Merced College',
  registrationPortalName: 'MC Portal',
  exampleCourseCodes: ['CPSC-01', 'ENGL-C1000', 'BIOL-04A'],
  colors: mercedCollegeColors,
};
